/* eslint-disable class-methods-use-this */
import EventClass from "common/utils/ui/event-class";
import { track } from "jiffy-analytics";

class DTFCategoryFilter extends EventClass {
  #$easyShoppingOriginalSibling;

  get #$sections() {
    return document.querySelectorAll(".js-dtf-category");
  }

  get #$sectionFillers() {
    return document.querySelectorAll(".js-dtf-category-filler");
  }

  get #$easyShopping() {
    return document.querySelector(".js-dtf-category-easy-shopping");
  }

  get #$tabHeader() {
    return document.querySelector(".js-dtf-category-header");
  }

  get #$mostPopularTab() {
    return this.#$tabHeader?.querySelector('[data-header-section="Most Popular"]');
  }

  get #$allProductsTab() {
    return this.#$tabHeader?.querySelector('[data-header-section="All Products"]');
  }

  get #$mostPopularSection() {
    return document.querySelector('[data-section="Most Popular"]');
  }

  get #$allOtherSections() {
    return document.querySelectorAll('[data-section]:not([data-section="Most Popular"])');
  }

  constructor() {
    super({
      eventSelector: ".js-dtf-category-header"
    });

    this.init();
  }

  init() {
    const $easyShopping = this.#$easyShopping;
    const $sectionContainer = this.#$sections[0]?.parentElement;
    if ($easyShopping && $sectionContainer) {
      $sectionContainer.appendChild($easyShopping);
    }

    this.#handleHashBasedNavigation();
  }

  #handleHashBasedNavigation() {
    const $tabHeader = this.#$tabHeader;
    if (!$tabHeader) return;

    const currentHash = window.location.hash.substring(1);

    if (this.#isNonMostPopularHash(currentHash)) {
      this.#showAllProductsView();
    } else if (currentHash === "most-popular") {
      this.#showMostPopularView();
    } else {
      this.#showDefaultView();
    }
  }

  #isNonMostPopularHash(hash) {
    return hash && hash !== "most-popular" && hash !== "";
  }

  #showAllProductsView() {
    this.#setActiveTab("all-products");
    this.#setSectionVisibility({ mostPopular: false, others: true });
  }

  #showMostPopularView() {
    this.#setActiveTab("most-popular");
    this.#setSectionVisibility({ mostPopular: true, others: false });
  }

  #showDefaultView() {
    // Both desktop and mobile should show all products by default
    this.#showAllProductsView();
  }

  #setActiveTab(activeTab) {
    const isMostPopular = activeTab === "most-popular";
    this.#$mostPopularTab?.classList.toggle("active", isMostPopular);
    this.#$allProductsTab?.classList.toggle("active", !isMostPopular);
  }

  #setSectionVisibility({ mostPopular, others }) {
    this.#$mostPopularSection?.classList.toggle("hidden", !mostPopular);
    this.#$allOtherSections.forEach($section => {
      $section.classList.toggle("hidden", !others);
    });
  }

  /* eslint-disable max-lines-per-function */
  event(e, $header) {
    const { headerSection } = e.target.dataset;
    if ($header && headerSection) {
      track("dtf_category_selected", { category: headerSection });
      const isAllProducts = headerSection === "All Products";
      const $headingItems = Array.from($header.children);
      // Match the index of the heading item with the index of the section
      const $sections = [null, ...Array.from(this.#$sections)];
      const $sectionFillers = Array.from(this.#$sectionFillers);
      const $easyShopping = this.#$easyShopping;
      const $sectionContainer = this.#$sections[0].parentElement;

      $headingItems.forEach(($heading, index) => {
        $heading.classList.toggle("active", $heading.dataset.headerSection === headerSection);

        if (index > 0) {
          const $sectionHeader = $sections[index]?.querySelector(".js-products-header");
          if ($sectionHeader) {
            $sectionHeader.classList.toggle("hidden", !isAllProducts);
          }
          if ($sections[index]) {
            $sections[index].classList.toggle(
              "hidden",
              !(isAllProducts || $sections[index].dataset.section === headerSection)
            );
          }
        }

        // Move easy shopping to the correct position
        if (isAllProducts && $easyShopping) {
          if (index === 3) {
            $sections[index]?.appendChild($easyShopping);
          }
        } else {
          $sectionContainer?.appendChild($easyShopping);
        }
      });

      $sectionFillers.forEach($filler => {
        $filler.classList.toggle("hidden", !isAllProducts);
      });

      // Handle Most Popular section visibility
      const isMostPopular = headerSection === "Most Popular";
      const $mostPopularSection = document.querySelector('section[data-section="Most Popular"]');
      if ($mostPopularSection) {
        $mostPopularSection.classList.toggle("hidden", !isMostPopular);
      }
    }
  }
}

export default () => new DTFCategoryFilter();
